import { EmptyRecord } from './types';

export const isEmptyRecord = (record: Record<PropertyKey, unknown>): record is EmptyRecord =>
    Object.values(record).every((value) => value === undefined);
